import {
  QueryClient,
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import {
  permitKeys,
  RequestTypes,
} from '@core/react-query/features/permits/permit'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const getRespondToBriefingMutationOptions = (
  queryClient: QueryClient,
  options: Parameters<typeof useRespondToBriefing>[0] = {},
): Parameters<typeof useRespondToBriefing>[0] => {
  return {
    ...(options ?? {}),
    ...permitKeys.respondToBriefing,
    onSuccess: (...args) => {
      const [, variables] = args

      queryClient.invalidateQueries(
        permitKeys.byId({ permitId: variables.permitId }).queryKey,
      )

      options?.onSuccess?.(...args)
    },
  }
}

export const useRespondToBriefing = (
  options: UseMutationOptions<
    void,
    RequestErrorType,
    RequestTypes['respondToBriefing']
  > = {},
) => {
  const queryClient = useQueryClient()

  return useMutation(getRespondToBriefingMutationOptions(queryClient, options))
}
